<template>
  <v-lazy-image :src="src" :src-placeholder="srcPlaceholder" alt="Periscope" />
</template>

<script>
export default {
  props: {
    src: String,
    srcPlaceholder: {
      default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjeP380H8ACOkDlOm641wAAAAASUVORK5CYII=',
      type: String,
    },
  },
}
</script>  
<style scoped>
.v-lazy-image {
  opacity: 0;
  transition: opacity 2s;
}
.v-lazy-image-loaded {
  opacity: 1;
}
</style>